export default __webpack_public_path__ + "static/media/one-point-jump.3982d664.md";